import React, { useState } from "react";
import axios from "axios";
import "../styles/custome/custome.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Contact() {
  // const [name, setName] = useState();
  // const [email, setEmail] = useState();
  // const [description, setDescription] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const sendData = (values) => {
    setIsLoading(true);
    axios
      .post("https://coming.codeamooz.com/ContactSoft_Service/", {
        name: values.name,
        email: values.email,
        description: values.description,
      })
      .then(function (response) {
        formik.resetForm();
        setIsLoading(false);
        toast.success("Your request has been sent successfully", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((err)=>{
        setIsLoading(false);
        toast.error('something went wrong, send requenst again!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
      });
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("* name is required"),
    email: Yup.string()
      .email("* Invalid email format")
      .required("* email is required"),
    description: Yup.string().required("* description is required"),
  });
  const initialValues = { name: "", email: "", description: "" };
  const formik = useFormik({
    initialValues,
    onSubmit: sendData,
    validationSchema,
  });

  return (
    <div>
      <div className="">
        <ToastContainer
          className="text-[16px] w-max smaller-screen:!w-[40rem] px-[2rem] absolute"
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          
        />
      </div>
      <div className="contact mt-[6rem]  px-4 mx-auto opacity" id="contact">
        <div className="container smallest-screen:pt-14 pt-24 pb-40 px-contact smallest-screen:px-0 sm:px-64 px-22">
          <h3 className="text-[3rem] sm:text-[4rem] sm:text-left text-center ">
            Contact
          </h3>
          <div className="">
            <p className=" mt-24 text-[1.8rem] text-purple">
              Send your request, we will call back to you !
            </p>
            <form
              noValidate
              className="relative mt-9 text-[1.6rem] flex flex-col gap-10 w-full"
              //   onSubmit={formik.handleSubmit}
              onSubmit={formik.handleSubmit}
            >
              <div>
                <input
                  className="mb-1 py-5 px-6 w-full border border-purple rounded-lg bg-transparent placeholder:text-purple"
                  type="text"
                  placeholder="Your name"
                  required
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  name="name"
                  onBlur={formik.handleBlur}
                />
                {formik.errors.name && formik.touched.name && (
                  <div className="text-red-600">{formik.errors.name}</div>
                )}
              </div>
              <div>
                <input
                  className="mb-1 py-5 px-6 w-full border border-purple rounded-lg bg-transparent placeholder:text-purple"
                  type="email"
                  placeholder="Your Email"
                  required
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  name="email"
                  onBlur={formik.handleBlur}
                />
                {formik.errors.email && formik.touched.email && (
                  <div className="text-red-600">{formik.errors.email}</div>
                )}
              </div>
              <div>
                <textarea
                  className="py-5 px-6 w-full border border-purple rounded-lg bg-transparent placeholder:text-purple"
                  placeholder="Description"
                  minLength={20}
                  required
                  onChange={formik.handleChange}
                  value={formik.values.description}
                  name="description"
                  onBlur={formik.handleBlur}
                />
                {formik.errors.description && formik.touched.description && (
                  <div className="text-red-600">
                    {formik.errors.description}
                  </div>
                )}
              </div>
              <button
                disabled={isLoading ? true : false}
                type="submit"
                href="#"
                className="self-center sm:self-end bg-pink text-white px-14 py-6 sm:p-6 text-[1.2rem] rounded-lg"
              >
                Send request
              </button>
              <div
                role="status"
                className={`absolute bottom-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 ${
                  isLoading ? "" : "hidden"
                }`}
              >
                <svg
                  aria-hidden="true"
                  class="w-20 h-20 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="rgb(222,53,146)"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="white"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
